import * as fromDatatype from '../datatype-library/index';

export interface bl_datalib_weather_forecast_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    date_time: fromDatatype.VarcharDatatypeInterface;
	geoloc_latitude: fromDatatype.NumericDatatypeInterface;
	geoloc_longitude: fromDatatype.NumericDatatypeInterface;
	data: fromDatatype.JsonDatatypeInterface;
	data_source: fromDatatype.VarcharDatatypeInterface;
	data_version: fromDatatype.VarcharDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	descr: fromDatatype.VarcharDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_datalib_weather_forecast_RowClass implements bl_datalib_weather_forecast_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
    date_time: fromDatatype.VarcharDatatypeInterface;
	geoloc_latitude: fromDatatype.NumericDatatypeInterface;
	geoloc_longitude: fromDatatype.NumericDatatypeInterface;
	data: fromDatatype.JsonDatatypeInterface;
	data_source: fromDatatype.VarcharDatatypeInterface;
	data_version: fromDatatype.VarcharDatatypeInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	descr: fromDatatype.VarcharDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
